import {AxiosResponse} from 'axios';
import {Job} from 'bull';
import {axiosAuthInstance} from './axiosInstanceAuth';
import {ItemInterface} from './item';

interface CreateVoucherPayload {
  vouchers: string[];
}

export interface CreateVoucherResponse {
  vouchers: string[];
  leaves: string[];
  rootHash: string;
}

interface CreateVoucherClaimableNftPayload {
  walletAddress: string;
  metadataUri: string;
  voucherHashes: string[];
  voucherRootHash: string;
  itemUuid: string;
}

interface CreateVoucherClaimableNftBatchPayload {
  toAddress: string;
  uris: string[];
  voucherHashes: string[];
  itemUuids: string[];
}

interface GetItemByVoucher {
  voucher: string;
}

interface RedeemItemByVoucher {
  voucher: string;
  receiver: string;
}

export const createVoucherHashesApi = async ({
  vouchers,
}: CreateVoucherPayload): Promise<CreateVoucherResponse> => {
  return axiosAuthInstance
    .post('voucher/create-voucher', {voucher: vouchers})
    .then((response: AxiosResponse<CreateVoucherResponse>) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
};

export const createVoucherClaimableNftApi = async ({
  walletAddress,
  metadataUri,
  voucherHashes,
  voucherRootHash,
  itemUuid,
}: CreateVoucherClaimableNftPayload): Promise<any> => {
  return axiosAuthInstance
    .post('voucher/create-nft-queue', {
      toAddress: walletAddress,
      tokenURI: metadataUri,
      voucherHashes: voucherHashes,
      voucherRootHash: voucherRootHash,
      itemUuid,
    })
    .then((response: AxiosResponse<any>) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
};

export const getItemByVoucher = async ({voucher}: GetItemByVoucher) => {
  return axiosAuthInstance
    .get('voucher/item/' + voucher)
    .then((response: AxiosResponse<ItemInterface>) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
};

export const redeemItemByVoucher = async ({voucher, receiver}: RedeemItemByVoucher) => {
  return axiosAuthInstance
    .post('voucher/claim-nft-queue', {voucher, toAddress: receiver})
    .then((response: AxiosResponse<Job>) => response.data)
    .catch((error) => error);
};

export const getRedeemItemByVoucherJob = async ({jobId}: {jobId: number}) => {
  return axiosAuthInstance
    .get(`voucher/claim-nft-queue/status/${jobId}`)
    .then((response: AxiosResponse<Job<any>>) => response.data)
    .catch((error) => error);
};

export const createVoucherClaimableNftBatchApi = async (
  payload: CreateVoucherClaimableNftBatchPayload,
) => {
  const job = await createNftQueueBatch(payload);
  // await pollCreateNftQueueBatchJobStatus(Number(job.id));
  return job;
};

const createNftQueueBatch = async (payload: CreateVoucherClaimableNftBatchPayload) => {
  return axiosAuthInstance
    .post('voucher/create-nft-queue-batch', payload)
    .then((response: AxiosResponse<Job>) => response.data)
    .catch((error) => error);
};

export async function* pollCreateNftQueueBatchJobStatus(jobId: number) {
  let progress = 0;
  while (progress < 100) {
    await new Promise((resolve) => setTimeout(resolve, 3000));
    const resp = await axiosAuthInstance.get(`voucher/job-status/${jobId}`);
    const job = resp.data;
    if (job.failedReason) {
      throw new Error(job.failedReason);
    }
    progress = Number(job.progress);
    yield progress;
  }
  return progress;
}
